import { css } from '@emotion/react';
var className = 'tab-content';
var defaultProps = {
  role: 'tabpanel'
};
var baseStyles = /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;");
export { baseStyles, className, defaultProps };
